module.exports = __webpack_public_path__ + "img/footer_logo.1f580bb.png";